import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth); // Access user from Redux store

  // Determine redirection based on user type
  const handleRedirect = () => {
    const role = user?.user_account_type || user?.role || user?.roles;

    if (["super_admin", "manager", "editor"].includes(role)) {
      navigate("/admin"); // Redirect to admin dashboard
    } else if (role === "customer") {
      navigate("/"); // Redirect to home page
    } else {
      navigate("/"); // Redirect to unauthorized page
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      {/* Main Content Card */}
      <div className="w-full max-w-md bg-white rounded-xl shadow-md overflow-hidden p-8 text-center">
        {/* Error Illustration */}
        <div className="mb-6">
          <svg
            className="w-32 h-32 mx-auto text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>

        {/* Error Title */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Page Not Found</h2>

        {/* Error Message */}
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={handleRedirect}
            className="px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-100 transition-colors shadow-sm"
          >
            Return Home
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center text-gray-500 text-sm">
        <p>© {new Date().getFullYear()} Company Name. All rights reserved.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;